import Controller from '@ember/controller';

export default class FaqsController extends Controller {
  queryParams = ['preserveScrollPosition'];
  preserveScrollPosition = true;
}
